import Modal from "antd/lib/modal/Modal";
import clsx from "clsx";
import { APP_COLOR } from "constant";
import React from "react";
import { useTranslation } from "react-i18next";
import { OtherUtil } from "utils/other";
import { PlusIcon } from "../Icon/Plus";
import "./HAModal.style.scss";
import { P_Props } from "./HAModal.type";

/**
 * Header Action Pattern cho cac modal
 * Cac props duoi day neu ko truyen vao thi se ko render
 * @param title @param onClose @param actions
 */
const HAModalPresenter: React.FC<P_Props> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      width={props.width}
      style={{ height: props.height }}
      bodyStyle={{ padding: 0 }}
      visible={props.visible}
      centered
      closable={false}
      footer={false}
      destroyOnClose
      className={clsx({ "ha-modal": true, [props.className || ""]: Boolean(props.className) })}
    >
      <div className="ha-modal__inner">
        <div className="ha-modal__inner__header">
          {props.title && typeof props.title === "string" && (
            <span className="ha-modal__inner__header__label">{t(props.title)}</span>
          )}
          {props.title && typeof props.title !== "string" && (
            <span className="ha-modal__inner__header__label">{props.title}</span>
          )}
          {props.onClose && (
            <PlusIcon
              onClick={() => OtherUtil.loadCallback(props.onClose)}
              className="ha-modal__inner__header__close"
              color={APP_COLOR.DARK_GRAY}
              size={[22, 22]}
              viewBox={[22, 22]}
            />
          )}
        </div>
        {props.children && <div className="ha-modal__inner__body">{props.children()}</div>}
        {props.actions && <div className="ha-modal__inner__footer">{props.actions}</div>}
      </div>
    </Modal>
  );
};

export default HAModalPresenter;
